var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient",style:({
    'height': Number(_vm.fontsize) + 10 + 'px',
    'line-height': Number(_vm.fontsize) + 10 + 'px',
  })},[_c('span',{style:({
      'font-size': _vm.fontsize + 'px',
      'color': _vm.fontcolor,
      'background': _vm.bgColor
    })},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }